import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import ConectUs from "../../components/ConectUs";

import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";

import inicio from "../../img/iconsoferta/inicio.png";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import Block5Columns from "../../components/Block5Columns";
import Block3Columns from "../../components/Block3Columns";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockRightImage from "../../components/BlockRightImage";
import EnLineaPagos from "../../components/Enlineapagos";
import AccordionFromHtml from "../../components/Accordionfromhtml";

function CarreraRecursosNaturales() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div className="carrera-riesgos">
            {" "}
            <div className="relative">
              <BlockImageCabecera
                src={item.field_imagen_principal}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_formulario_informacion,
                      }}
                    />

                    {item?.field_modalidad_a_distancia == "1" && (
                      <a target="_blank" href="https://matriculas.utpl.edu.ec">
                        Matricúlate hoy
                      </a>
                    )}
                  </>
                }
              ></BlockImageCabecera>

              <DistanciaNuevosFixed></DistanciaNuevosFixed>
            </div>
            <div className="lightbluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/en-linea">En línea</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/carrera-recursos-naturales">
                      Ingeniería en Recursos Naturales y Sostenibilidad
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons ">
                <p
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_carrera_resolucion,
                  }}
                />

                <Block5Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_carrera_titulo_otorga,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>

                      {item?.field_modalidad_a_distancia == "1" && (
                        <p>En línea</p>
                      )}
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_carrera_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={sale}></img>
                      <p>
                        <b>Inversión</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_costo_modalidad_linea,
                        }}
                      />

                      <a
                        className="link-with-arrow fontsize10pt"
                        href="#descuentos"
                      >
                        Accede a becas y descuentos
                      </a>
                    </>
                  }
                  col5={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_fecha_de_inicio,
                        }}
                      />
                    </>
                  }
                ></Block5Columns>
              </div>
            </div>
            <div className="padding graybg">
              <Block3Columns
                col1={
                  <>
                    <h2>
                      🎓 Ingeniería con propósito para un futuro sostenible
                    </h2>
                    <p>
                      Única carrera de Ingeniería en el Ecuador especializada en
                      Recursos Naturales y Sostenibilidad, con un enfoque
                      innovador, tecnológico y orientado al futuro.
                    </p>

                    <a className="link-with-arrow fontsize10pt" href="#malla">
                      Ver malla curricular
                    </a>
                  </>
                }
                col2={
                  <>
                    <h2>💼 Formación integral para el desarrollo sostenible</h2>
                    <p>
                      Enfrenta los desafíos ambientales globales y locales,
                      integrando tecnologías emergentes, pensamiento sostenible
                      y trabajo con la comunidad.{" "}
                    </p>

                    <a
                      className="link-with-arrow fontsize10pt"
                      href="#estudiar"
                    >
                      ¿Por qué estudiar Ingeniería en Energía en la UTPL?
                    </a>
                  </>
                }
                col3={
                  <>
                    <h2>🌐 Prepárate con prácticas y proyectos reales</h2>
                    <p>
                      Aprende a través de proyectos reales y prácticas
                      progresivas, alineadas con los Objetivos de Desarrollo
                      Sostenible (ODS), para una formación actual y con impacto.
                    </p>

                    <a className="link-with-arrow fontsize10pt" href="#campo">
                      Conoce el campo ocupacional
                    </a>
                  </>
                }
              ></Block3Columns>
            </div>
            {/*     <div className="layout8 padding">
              <p
                dangerouslySetInnerHTML={{
                  __html: item.field_carrera_resolucion,
                }}
              />
              <center>
                {" "}
                <p className="iconsize20">🎓👨‍💼</p>
              </center>

              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_descripcion_de_la_carrera,
                }}
              />
            </div>{" "} */}
            <BlockBackgroundImage
              src={item.field_carrera_img_perfil}
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_carrera_perfil_profesional,
                    }}
                  />
                </>
              }
            ></BlockBackgroundImage>
            <div className=" padding " id="malla">
              <div className="layout6">
                <h2>
                  Nuestra malla curricular <br></br>{" "}
                  <b>
                    te prepara para transformar<br></br>
                  </b>
                   el entorno con conocimiento
                </h2>{" "}
              </div>
              <div
                className="itinerario-wrapper layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_carrera_itinerarios,
                }}
              />
              <div className="layout6 malla-curricular">
                <AccordionFromHtml htmlContent={item.field_carrera_semestre}>
                  {" "}
                </AccordionFromHtml>
                <br></br>
                {/*  <a className="link-with-arrow" href={item.field_carrera_malla}>
                  Descargar malla curricular
                </a> */}
                <p className="iconsize20 margin1em">🗣️🌍</p>
                <h3>
                  Demuestra tu dominio en una segunda lengua:
                  <b> requisito clave para tu graduación</b>
                </h3>{" "}
                <p>
                  Puedes cumplir este requisito rindiendo un examen de
                  ubicación, reconociendo certificados externos, homologando
                  títulos de tercer o cuarto nivel, o preparándote con nuestras
                  instituciones aliadas.
                </p>
                <a className="button" href="/segunda-lengua">
                  Más información
                </a>{" "}
              </div>
            </div>
            <div className="bluebg" id="campo">
              <BlockRightImage
                src={item.field_carrera_img_campo}
                content={
                  <>
                    <p className="iconsize20">💼🌍</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_carrera_campo_ocupacional,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>{" "}
            </div>
            <div>
              <EnLineaPagos></EnLineaPagos>
            </div>{" "}
            {/*      <div className="padding2 bluebg">
              <Notification
                content={
                  <>
                    <h2>
                      Estudia en la universidad{" "}
                      <b>#1 de educación en línea del país </b>
                    </h2>
                    <p>
                      Descubre un modelo educativo innovador, un sistema de
                      evaluación flexible y herramientas digitales que te
                      acompañarán en cada paso de tu formación profesional.
                    </p>
                    <a href="/estudiar-en-linea">Mas información</a>
                  </>
                }
              ></Notification>
            </div> */}
            <div id="estudiar">
              <BlockBackgroundImage
                src={item.field_carrera_img_porque_utpl}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_carrera_porque_en_utpl,
                      }}
                    />
                  </>
                }
              ></BlockBackgroundImage>
            </div>
               <div className="icon400 padding lightbluebg">
              <BlockRightImage
                src={item.field_carrera_img_coordinador}
                content={
                  <>
                    <p className="iconsize20">📣</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_carrera_msj_coordinador,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div> 
            <div className="wrapper-docente  padding">
              <div className="layout6">
                <center>
                  <h2>
                    <b> Docentes</b>
                  </h2>
                  <h4>
                    Conoce a nuestros docentes expertos, quienes con su amplia
                    trayectoria ofrecen una formación de excelencia.
                  </h4>
                  <br></br>
                </center>
              </div>

              <div
                className="flex-center"
                dangerouslySetInnerHTML={{
                  __html: item.field_carrera_docentes,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/carrera-recursos-naturales.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes en línea y a distancia."
        instagram="https://www.instagram.com/utplenlinea/"
        facebook="https://www.facebook.com/utplenlinea/"
        tiktok="https://www.tiktok.com/@utplenlinea"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default CarreraRecursosNaturales;
